import { useState, useEffect } from 'react';
import { Pagination } from '../../../../../model/pagination';
import { IItemPurchaseAddEditRequest } from '../../../../../model/scp/purchase/request/purchase-item-add-edit-request';
import { IPurchaseItemResponse as IItemPurchaseResponse } from '../../../../../model/scp/purchase/response/purchase-item-response';
import { IPurchaseItemPageRequest } from '../../../../../model/scp/purchase/request/purchase-item-paged-request';
import { ITableResponse } from '../../../../../model/scp/purchase/response/tables-response';
import BaseAppService from '../../../../../application/platform/scp/base/base-app-service';
import PurchaseAppService from '../../../../../application/platform/scp/purchase/purchase-app-service';
import { IGetPurchaseItemResultRequest } from '../../../../../model/scp/purchase-item-result/request/get-purchase-item-result-request';
import { IPurchaseItemResultResponse } from '../../../../../model/scp/purchase-item-result/response/purchase-item-result-response';
import { useBaseLayout } from '../../../../../components/context/use-base-layout';

export const usePurchaseItemController = (
    purchaseId: string | undefined,
    modalityId: number | null | undefined,
    setItemsPurchaseJson: (value: string) => void,
    initialItemsJson?: string
) => {
    const { showDialog, showMessage, showLoading } = useBaseLayout();
    const [itemPurhase, setItemPurchase] = useState<IItemPurchaseAddEditRequest>({ budgetConfidential: false, basicProductiveIncentive: false });
    const [openDrawer, setOpenDrawer] = useState<boolean>(false);
    const [materialService, setMaterialService] = useState<ITableResponse[]>([]);
    const [benefitType, setBenefitType] = useState<ITableResponse[]>([]);
    const [judgementCriteria, setJudgementCriteria] = useState<ITableResponse[]>([]);
    const [categoryItemPurchase, setCategoryItemPurchase] = useState<ITableResponse[]>([]);
    const [purchaseItemSituation, setPurchaseItemSituation] = useState<ITableResponse[]>([]);
    const [titleDrawer, setTitleDrawer] = useState<string>("Novo Item");

    // Inicializa com os itens do contexto se existirem
    const getInitialItems = (): Pagination<IItemPurchaseResponse> => {
        if (purchaseId === undefined && initialItemsJson) {
            try {
                const items = JSON.parse(initialItemsJson);
                return {
                    items: items,
                    page: 1,
                    pageSize: 100,
                    pageCount: Math.ceil(items.length / 100),
                    totalRecords: items.length
                } as Pagination<IItemPurchaseResponse>;
            } catch (error) {
                // Erro ao parsear JSON de itens - retorna lista vazia
                showMessage({
                    open: true,
                    message: 'Não foi possível recuperar os itens salvos anteriormente',
                    detail: (error as any).details || (error as Error).message,
                    type: 'warning'
                });
            }
        }
        return { items: [] } as unknown as Pagination<IItemPurchaseResponse>;
    };

    const [purchaseItemsResponse, setPurchaseItemsResponse] = useState<Pagination<IItemPurchaseResponse>>(getInitialItems());
    const [purchaseItemsRequest, setPurchaseItemsRequest] = useState<IPurchaseItemPageRequest>({ id: purchaseId, page: 1, pageSize: 100 } as IPurchaseItemPageRequest);
    const [loadMoreData, setLoadMoreData] = useState(false);
    const [openResultDrawer, setOpenResultDrawer] = useState(false);
    const [selectedItemForResult, setSelectedItemForResult] = useState<number | null>(null);
    const [itemResult, setItemResult] = useState<IPurchaseItemResultResponse | null>(null);

    useEffect(() => {
        loadTables();
    }, [modalityId]);

    useEffect(() => {
        loadData();
    }, [purchaseId]);

    useEffect(() => {
        if (purchaseItemsResponse.items !== undefined) {
            setItemsPurchaseJson(JSON.stringify(purchaseItemsResponse.items));
        }
    }, [purchaseItemsResponse.items]);

    const loadTables = async () => {
        let modality = modalityId;

        const instrumentSummons = await BaseAppService.listMaterialService(modality);
        setMaterialService(instrumentSummons);

        const benefitTypeList = await BaseAppService.listBenefitType(modality);
        setBenefitType(benefitTypeList);

        const jugmentCriteria = await BaseAppService.listJudgmentCriteria(modality);
        setJudgementCriteria(jugmentCriteria);

        const categoryItemPurchaseList = await BaseAppService.listCategoryItemPurchase(modality);
        setCategoryItemPurchase(categoryItemPurchaseList);

        const purchaseItemSituationList = await BaseAppService.listPurchaseItemSituation();
        setPurchaseItemSituation(purchaseItemSituationList);
    };

    const loadData = async () => {
        if (purchaseItemsRequest.id !== undefined) {
            setLoadMoreData(true);
            const purchaseItems = await PurchaseAppService.listPurchaseItems(purchaseItemsRequest);
            setPurchaseItemsResponse(purchaseItems);
            setLoadMoreData(false);
        }
    };

    const getPurchaseItemResult = async (purchaseId: number, itemNumber: number, resultSequence: number) => {
        showLoading({ open: true });
        const result = await PurchaseAppService.getPurchaseItemResult({ purchaseId, itemNumber, resultSequence } as IGetPurchaseItemResultRequest);
        setItemResult(result);
        showLoading({ open: false });
    };

    const deleteItem = (number: number | undefined) => {
        if (purchaseItemsRequest.id === undefined && number !== undefined) {
            const result = purchaseItemsResponse.items.filter((item) => item.number !== number);
            setPurchaseItemsResponse({ items: result, page: purchaseItemsResponse.pageSize, pageSize: purchaseItemsResponse.pageSize, pageCount: purchaseItemsResponse.pageCount, totalRecords: result.length } as unknown as Pagination<IItemPurchaseResponse>);
            setItemsPurchaseJson(JSON.stringify(result));
        }
    };

    const handleOnChange = (e: any) => {
        let amount = itemPurhase?.amount;
        let basicProductiveIncentive = itemPurhase?.basicProductiveIncentive;
        let typeItemId = itemPurhase?.typeItemId;
        let budgetConfidential = itemPurhase?.budgetConfidential;
        let categoryItemId = itemPurhase?.categoryItemId;
        let criterionJudgmentId = itemPurhase?.criterionJudgmentId;
        let description = itemPurhase?.description;
        let patrimony = itemPurhase?.patrimony;
        let quantity = itemPurhase?.quantity;
        let unitMeasure = itemPurhase?.unitMeasure;
        let realEstateRegistryCode = itemPurhase?.realEstateRegistryCode;
        let typeBenefitId = itemPurhase?.typeBenefitId;
        let typeItem = itemPurhase?.typeItem;
        let unitValueEstimated = itemPurhase?.unitValueEstimated;
        let situationPurchaseItemId = itemPurhase?.situationPurchaseItemId;

        if (e !== undefined) {
            if (e.target.name === "input-amount") {
                amount = e.target.value;
            } else if (e.target.name === "check-basic-produtive-incentive") {
                basicProductiveIncentive = e.target.checked;
            } else if (e.target.name === "check-budget-confidential") {
                budgetConfidential = e.target.checked;
            } else if (e.target.name === "select-category-item") {
                categoryItemId = e.target.value;
            } else if (e.target.name === "select-criterion-judgment") {
                criterionJudgmentId = e.target.value;
            } else if (e.target.name === "input-description") {
                description = e.target.value;
            } else if (e.target.name === "input-patrimony") {
                patrimony = e.target.value;
            } else if (e.target.name === "input-quantity") {
                quantity = e.target.value;
            } else if (e.target.name === "input-unit-measure") {
                unitMeasure = e.target.value;
            } else if (e.target.name === "input-real-estate-registry-code") {
                realEstateRegistryCode = e.target.value;
            } else if (e.target.name === "select-type-benefit") {
                typeBenefitId = e.target.value;
            } else if (e.target.name === "select-type-item") {
                typeItem = e.target.value;
                typeItemId = e.target.value;
            } else if (e.target.name === "input-unit-value-estimated") {
                unitValueEstimated = e.target.value;
            } else if (e.target.name === "select-situation-purchase-item") {
                situationPurchaseItemId = e.target.value;
            }
        }

        setItemPurchase(prevState => {
            return { ...prevState, amount, basicProductiveIncentive, typeItemId, situationPurchaseItemId, budgetConfidential, categoryItemId, criterionJudgmentId, description, patrimony, quantity, unitMeasure, realEstateRegistryCode, typeBenefitId, typeItem, unitValueEstimated };
        });
    };

    const handleCurrencyChange = (value: string | undefined, name: string) => {
        const numericValue = parseFloat(value || '0');

        setItemPurchase(prevState => {
            const updatedState = { ...prevState };

            if (name === 'input-unit-value-estimated') {
                updatedState.unitValueEstimated = numericValue;
                // Calcula o valor total automaticamente
                const qty = updatedState.quantity || 0;
                updatedState.amount = numericValue * qty;
            } else if (name === 'input-quantity') {
                updatedState.quantity = numericValue;
                // Calcula o valor total automaticamente
                const unitPrice = updatedState.unitValueEstimated || 0;
                updatedState.amount = unitPrice * numericValue;
            } else if (name === 'input-amount') {
                updatedState.amount = numericValue;
            }

            return updatedState;
        });
    };

    const addItem = () => {
        setTitleDrawer("Adicionar Item");
        setItemPurchase({ basicProductiveIncentive: false, budgetConfidential: false });
        setOpenDrawer(true);
    };

    const editItem = (itemNumber: number | undefined) => {
        const result = purchaseItemsResponse.items.find((item) => item.number === itemNumber);
        if (result !== undefined) {
            setItemPurchase({ ...result, typeItem: result.typeItemId });
            setOpenDrawer(true);
            setTitleDrawer("Editar Item Nº " + result.number);
        } else {
            showMessage({ message: 'Item não encontrado', type: 'error', open: true });
        }
    };

    const validFields = (): boolean => {
        let isValid = true;

        if (itemPurhase.categoryItemId === undefined) {
            isValid = false;
        }
        if (itemPurhase.categoryItemId !== undefined && itemPurhase.categoryItemId === 1 && (itemPurhase.realEstateRegistryCode === undefined || itemPurhase.realEstateRegistryCode.length === 0)) {
            isValid = false;
        }
        if (itemPurhase.typeItem === undefined) {
            isValid = false;
        }
        if (itemPurhase.typeBenefitId === undefined) {
            isValid = false;
        }
        if (itemPurhase.criterionJudgmentId === undefined) {
            isValid = false;
        }
        if (itemPurhase.unitMeasure === undefined) {
            isValid = false;
        }
        if (itemPurhase.unitValueEstimated === undefined || itemPurhase.unitValueEstimated === 0) {
            isValid = false;
        }
        if (itemPurhase.quantity === undefined || itemPurhase.quantity === 0) {
            isValid = false;
        }
        if (itemPurhase.amount === undefined || itemPurhase.amount === 0) {
            isValid = false;
        }
        if (itemPurhase.description === undefined || itemPurhase.description.length === 0) {
            isValid = false;
        }

        return isValid;
    };

    const mapToApiFormat = (item: IItemPurchaseAddEditRequest): IItemPurchaseAddEditRequest => {
        // Mapeia do formato interno do formulário para o formato da API
        const materialOuServico = item.typeItemId === 1 ? 'M' : item.typeItemId === 2 ? 'S' : 'M';

        return {
            numeroItem: item.number,
            materialOuServico: materialOuServico,
            tipoBeneficioId: item.typeBenefitId?.toString() || '1',
            incentivoProdutivoBasico: item.basicProductiveIncentive || false,
            aplicabilidadeMargemPreferenciaNormal: false,
            aplicabilidadeMargemPreferenciaAdicional: false,
            inConteudoNacional: true,
            descricao: item.description || '',
            quantidade: item.quantity || 0,
            unidadeMedida: item.unitMeasure || '',
            valorUnitarioEstimado: item.unitValueEstimated || 0,
            valorTotal: item.amount || 0,
            orcamentoSigiloso: item.budgetConfidential || false,
            criterioJulgamentoId: item.criterionJudgmentId?.toString() || '1',
            itemCategoriaId: item.categoryItemId || 1,
            patrimonio: item.patrimony || '',
            codigoRegistroImobiliario: item.realEstateRegistryCode || '',
            catalogoId: 1,
            categoriaItemCatalogoId: 1,
            catalogoCodigoItem: 1,
            // Mantém os campos internos para exibição
            ...item
        };
    };

    const saveItem = async () => {
        if (validFields()) {
            const item = Object.assign({} as IItemPurchaseResponse, itemPurhase);

            if (item.number === undefined) {
                item.number = purchaseItemsResponse.totalRecords !== undefined ? purchaseItemsResponse.totalRecords + 1 : 1;
                if (purchaseItemsRequest.id === undefined) {
                    const mappedItem = mapToApiFormat(item) as IItemPurchaseResponse;
                    setPurchaseItemsResponse({ items: [...purchaseItemsResponse.items, mappedItem], page: purchaseItemsResponse.pageSize, pageSize: purchaseItemsResponse.pageSize, pageCount: purchaseItemsResponse.pageCount, totalRecords: item.number } as unknown as Pagination<IItemPurchaseResponse>);
                    setOpenDrawer(false);
                    showMessage({ open: true, message: "Item adicionado com sucesso!", type: "success" });
                } else {
                    showLoading({ open: true });
                    const mappedItem = mapToApiFormat(item);
                    await PurchaseAppService.addItemsPurchase(Number(purchaseItemsRequest.id), [mappedItem] as IItemPurchaseAddEditRequest[]);
                    showLoading({ open: false });
                    setOpenDrawer(false);
                    await loadData();
                    showMessage({ open: true, message: "Item adicionado com sucesso!", type: "success" });
                }
            } else {
                if (purchaseItemsRequest.id === undefined) {
                    let result = purchaseItemsResponse.items.filter((i) => i.number !== item.number);
                    const mappedItem = mapToApiFormat(item) as IItemPurchaseResponse;
                    result = [...result, mappedItem];
                    setPurchaseItemsResponse({ items: result, page: purchaseItemsResponse.pageSize, pageSize: purchaseItemsResponse.pageSize, pageCount: purchaseItemsResponse.pageCount, totalRecords: result.length } as unknown as Pagination<IItemPurchaseResponse>);
                    setItemsPurchaseJson(JSON.stringify(result));
                    setOpenDrawer(false);
                    showMessage({ open: true, message: "Item alterado com sucesso!", type: "success" });
                } else {
                    showLoading({ open: true });
                    const mappedItem = mapToApiFormat(item);
                    await PurchaseAppService.updateItemPurchase(Number(purchaseItemsRequest.id), Number(item.number), mappedItem);
                    showLoading({ open: false });
                    setOpenDrawer(false);
                    await loadData();
                    showMessage({ open: true, message: "Item alterado com sucesso!", type: "success" });
                }
            }
        } else {
            showMessage({ open: true, message: "Preencha todos os campos obrigatórios!", type: "error" });
        }
    };

    const openItemResultDrawer = (itemNumber: number) => {
        setSelectedItemForResult(itemNumber);
        getPurchaseItemResult(Number(purchaseId), itemNumber, 1);
        setOpenResultDrawer(true);
    };

    const closeItemResultDrawer = () => {
        setOpenResultDrawer(false);
        setItemResult(null);
        setSelectedItemForResult(null);
    };

    const handleResultSave = () => {
        if (purchaseItemsRequest.id !== undefined) {
            loadData();
        }
    };

    const handlePageChange = (newPage: number) => {
        setPurchaseItemsRequest({ ...purchaseItemsRequest, page: newPage });
    };

    return {
        // State
        itemPurhase,
        openDrawer,
        setOpenDrawer,
        materialService,
        benefitType,
        judgementCriteria,
        categoryItemPurchase,
        purchaseItemSituation,
        titleDrawer,
        purchaseItemsResponse,
        purchaseItemsRequest,
        loadMoreData,
        openResultDrawer,
        selectedItemForResult,
        itemResult,

        // Methods
        handleOnChange,
        handleCurrencyChange,
        addItem,
        editItem,
        saveItem,
        deleteItem,
        openItemResultDrawer,
        closeItemResultDrawer,
        handleResultSave,
        handlePageChange,
        validFields,
        showDialog,
        showMessage,
        showLoading
    };
};
